import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';

import { VehicleGroupReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
    providedIn: 'root'
})
export class VehicleGroupReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/VehicleGroupReferences"

    constructor(httpClient: HttpClient,
        authService: AuthService,) {
        super(httpClient, authService);
    }

    public getVehicleGroupReference(): Observable<VehicleGroupReferenceModel[]> {
        return this.httpGet<VehicleGroupReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}